// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NutStatCal from './screen/NutStatCal';
import NutStatCalBMI from './screen/NutStatCalBMI';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NutStatCal />} />
        <Route path="/nutstatcal_bmi" element={<NutStatCalBMI />} />
      </Routes>
    </Router>
  );
}
